<template>
  <v-menu
    offset-y
    left
    :nudge-bottom="6"
    transition="fade-transition"
    content-class="new-template-menu"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        color="primary"
        class="new-template-menu__btn text-none white--text"
        :disabled="disabled"
        :data-testid="dataTestid"
      >
        <v-icon left small>mdi-plus</v-icon>
        New template
        <v-icon right small>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <div class="new-template-menu__panel" :data-testid="`${dataTestid}__panel`">
      <p class="new-template-menu__heading ma-0" :data-testid="`${dataTestid}__heading`">
        {{ heading }}
      </p>
      <button
        v-for="item in items"
        :key="item.feature"
        type="button"
        class="new-template-menu__item"
        :data-testid="`${dataTestid}__item--${item.feature}`"
        @click="$emit('select', item.feature)"
      >
        <v-icon small class="new-template-menu__icon">{{ item.icon }}</v-icon>
        <span class="new-template-menu__copy">
          <span class="new-template-menu__title">{{ item.label }}</span>
          <span class="new-template-menu__desc">{{ item.description }}</span>
        </span>
      </button>
    </div>
  </v-menu>
</template>

<script>
import './NewTemplateMenu.scss';
import {
  NOTIFICATION_TEMPLATE_MENU,
  NOTIFICATION_TEMPLATE_MENU_HEADING,
} from '../../../../utils/constants';

export default {
  name: 'NewTemplateMenu',
  props: {
    disabled: { type: Boolean, default: false },
    dataTestid: { type: String, default: 'new-template-menu' },
  },
  data() {
    return {
      items: NOTIFICATION_TEMPLATE_MENU,
      heading: NOTIFICATION_TEMPLATE_MENU_HEADING,
    };
  },
};
</script>
